export interface NavbarLink {
  label: string
  href: string
  isNew?: boolean
}

export const navbarPathologies: NavbarLink[] = [
  { label: 'Ejaculação precoce', href: '/ejaculacao-precoce' },
  { label: 'Perda de libido', href: '/perda-de-libido' },
  { label: 'Problemas de ereção', href: '/disfuncao-eretil' },
  { label: 'Vida sexual', href: '/problemas-sexuais' },
  { label: 'PrEP - Prevenção HIV', href: '/prep' },
  { label: 'Harmonização Peniana', href: '/harmonizacao-peniana' },
  { label: 'Próstata aumentada', href: '/prostata-aumentada' }
]

export const navbarPathologiesSmartfit: NavbarLink[] = [
  { label: 'Ejaculação precoce', href: '/consultar' },
  { label: 'Perda de libido', href: '/consultar' },
  { label: 'Problemas de ereção', href: '/consultar' },
  { label: 'Vida sexual', href: '/consultar' },
  { label: 'PrEP - Prevenção HIV', href: '/consultar' },
  { label: 'Harmonização Peniana', href: '/consultar' },
  { label: 'Próstata aumentada', href: '/consultar' }
]

export const navbarDermatologyPathologies: NavbarLink[] = [
  { label: 'Calvície', href: '/calvicie' },
  { label: 'Acne', href: '/acne' },
  { label: 'Caspa', href: '/dermatite' },
  { label: 'Dermatologia geral', href: '/dermatologista' }
]
export const navbarDermatologyPathologiesSmartfit: NavbarLink[] = [
  { label: 'Calvície', href: '/consultar' },
  { label: 'Acne', href: '/consultar' },
  { label: 'Caspa', href: '/consultar' },
  { label: 'Dermatologia geral', href: '/consultar' }
]

export const navbarSpecialists: NavbarLink[] = [
  { label: 'Saúde sexual', href: '/profissionais?filter=urology' },
  { label: 'Pele&cabelo', href: '/profissionais?filter=dermatology' },
  { label: 'Psicologia', href: '/profissionais?filter=psychology' }
]

export const navbarCourses: NavbarLink[] = [
  { label: 'Programa Ereção', href: '/cursos/programa-master' },
  { label: 'Programa Ejaculação', href: '/cursos/programa-control' }
]

export const navbarProducts: NavbarLink[] = [
  { label: '+lib', href: '/produtos/mais-lib' },
  { label: '+fert', href: '/produtos/mais-fert' },
  { label: '+hair', href: '/produtos/mais-hair' }
]

export const navbarSexProducts: NavbarLink[] = [{ label: 'Libido e ereção', href: '/produtos/mais-lib' }]
